import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Stack,
  Typography,
} from "@mui/material";

function FormPageLayout({
  title,
  cardTitle,
  children,
  actions,
  formProps,
  cardClassName,
  headerClassName,
  cardContentProps,
  cardActionsProps,
}) {
  const { sx: cardActionsSx, ...restCardActionsProps } = cardActionsProps || {};

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 2,
      }}
    >
      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Typography variant="h4">{title}</Typography>
          <form {...formProps}>
            <Card className={cardClassName}>
              {cardTitle ? (
                <CardHeader
                  title={cardTitle}
                  className={headerClassName}
                  variant="h4"
                />
              ) : null}
              <Divider />
              <CardContent {...cardContentProps}>{children}</CardContent>
              {actions ? (
                <>
                  <Divider />
                  <CardActions
                    sx={
                      cardActionsSx
                        ? [{ justifyContent: "flex-end" }, cardActionsSx]
                        : { justifyContent: "flex-end" }
                    }
                    {...restCardActionsProps}
                  >
                    {actions}
                  </CardActions>
                </>
              ) : null}
            </Card>
          </form>
        </Stack>
      </Container>
    </Box>
  );
}

export default FormPageLayout;
